import u from 'umbrellajs/umbrella.esm.js';

export function initModal() {

  /* -------------------------
    General modal
  -------------------------- */
  const modal = u('#modal');

  const openModal = () => {
    modal.removeClass('hidden');
    u('body').addClass('overflow-hidden');
  };

  const closeModal = () => {
    modal.addClass('hidden');
    u('body').removeClass('overflow-hidden');
  };

  u('#open-modal').on('click', openModal);

  // Close modal if any link inside the modal is clicked
  u('#modal').on('click', 'a', (e) => {
      modal.addClass('hidden');
      u('body').removeClass('overflow-hidden');
      const input = u('.pagefind-ui__search-input').first();
      input.value = '';
  });

  // Close modal if the 'X' is clicked
  u('#close-nav-search, #search-modal > div:first-child').on('click', () => {
    modal.addClass('hidden');
    u('body').removeClass('overflow-hidden');
    const input = u('.pagefind-ui__search-input').nodes[0];
    if (input) {
      input.value = '';
    }
  });


  /* -------------------------
    Search modal
  -------------------------- */
  const modalSearch = u('#search-modal');

  const openSearchModal = () => {
    modalSearch.removeClass('hidden');
    u('body').addClass('overflow-hidden');

    const input = u('.pagefind-ui__search-input').first();
    if (input) input.focus();
  };

  const closeSearchModal = () => {
    modalSearch.addClass('hidden');
    u('body').removeClass('overflow-hidden');

    const input = u('.pagefind-ui__search-input').first();
    if (input) input.value = '';
  };

  u('#open-nav-search').on('click', openSearchModal);

  // Close modal if any link inside the modal is clicked
  u('#search-modal').on('click', 'a', (e) => {
      modalSearch.addClass('hidden');
      u('body').removeClass('overflow-hidden');
      const input = u('.pagefind-ui__search-input').first();
      input.value = '';
  });

  // Close modal if the 'X' is clicked
  u('#close-nav-search, #search-modal > div:first-child').on('click', () => {
    modalSearch.addClass('hidden');
    u('body').removeClass('overflow-hidden');
    const input = u('.pagefind-ui__search-input').nodes[0];
    if (input) {
      input.value = '';
    }
  });


  /* -------------------------
    Shared ESC handler
  -------------------------- */
  u(document).on('keydown', e => {
    if (e.key === 'Escape') {
      closeModal();
      closeSearchModal();
    }
  });

}